import type { LearnPracticalContent } from "../practicalContent.js";

export const medicinesContent: LearnPracticalContent = {
  th: {
    notice: [
      "ฉลากระบุชื่อยา ความแรง วิธีใช้ คำเตือน วันหมดอายุ และวิธีเก็บ",
      "ชื่อคล้ายกันหรือบรรจุภัณฑ์เปลี่ยนอาจทำให้หยิบยาผิด",
      "ยาที่สี กลิ่น รูปร่าง หรือเนื้อสัมผัสเปลี่ยนไปอาจเสื่อมสภาพแม้ยังไม่ถึงวันหมดอายุ",
      "ยาแก้ปวด แก้หวัด และผลิตภัณฑ์หลายชนิดอาจมีตัวยาซ้ำกัน จึงต้องอ่านส่วนประกอบ ไม่ดูเพียงชื่อการค้า",
    ],
    prepare: [
      "เก็บยาในบรรจุภัณฑ์เดิมพร้อมฉลาก และทำรายการยาที่ใช้อยู่",
      "ถามแพทย์หรือเภสัชกรเมื่อฉลากอ่านไม่ชัดหรือข้อมูลไม่ตรงกับที่ได้รับคำสั่ง",
      "บันทึกยา อาหารเสริม สมุนไพร และประวัติแพ้ยาเพื่อแจ้งผู้ประกอบวิชาชีพทุกครั้ง",
      "ตั้งการเตือนและจัดยาเฉพาะเมื่อสามารถติดตามได้ว่าเป็นยาของใคร วันใด และขนาดใด โดยคงฉลากเดิมไว้เสมอ",
    ],
    during: [
      "อ่านชื่อยา ความแรง ขนาด และเวลาบนฉลากก่อนใช้ทุกครั้ง",
      "ใช้ตามฉลากและคำสั่งของผู้ประกอบวิชาชีพสำหรับยาของคุณเท่านั้น",
      "ตรวจคำเตือน วิธีเก็บ และวันหมดอายุ รวมทั้งชื่อผู้ใช้เมื่อมียาหลายคนอยู่ใกล้กัน",
      "เมื่อไปรับบริการหรือซื้อยาเพิ่ม ให้แจ้งรายการยา อาหารเสริม สมุนไพร และประวัติแพ้ยาปัจจุบันทุกครั้ง",
    ],
    avoid: [
      "อย่าใช้ยาของผู้อื่น แบ่งยาให้ผู้อื่น หรือใช้ยาที่หมดอายุ",
      "อย่าเพิ่ม ลด หยุด หรือผสมยาเองเมื่อไม่แน่ใจ",
      "อย่าเก็บยาในรถ ห้องน้ำ แดด หรือความชื้น เว้นแต่ฉลากระบุวิธีเก็บเฉพาะไว้ต่างออกไป",
      "อย่าบด หัก แกะแคปซูล หรือเปลี่ยนวิธีใช้ยาเองเพียงเพื่อให้กลืนง่ายขึ้น หากยังไม่ได้ถามเภสัชกร",
    ],
    help: [
      "ติดต่อแพทย์หรือเภสัชกรเมื่อใช้ผิดขนาด มีอาการผิดปกติ หรือสงสัยปฏิกิริยาระหว่างยา",
      "หากมีอาการรุนแรง เช่น หายใจลำบากหรือหมดสติ ให้ขอความช่วยเหลือฉุกเฉิน",
      "หากยาเสียหาย ฉลากหาย หรือไม่แน่ใจว่ายังใช้ได้ ให้แยกยาไว้และถามเภสัชกรก่อนใช้หรือทิ้ง",
      "หากเด็กหรือบุคคลอื่นอาจกินยาเกินขนาด หรือไม่ทราบว่าได้รับยาอะไร ให้ขอคำแนะนำเร่งด่วนและนำภาชนะยาไปด้วยหากปลอดภัย",
    ],
    example:
      "ได้ยากล่องใหม่ที่หน้าตาคล้ายของเดิม: อ่านชื่อยา ความแรง ขนาด วิธีใช้ และวันหมดอายุบนฉลาก หากไม่ตรงกับที่ได้รับคำสั่ง ให้ถามเภสัชกรก่อนใช้",
    cautions: [
      {
        title: "เกรปฟรุตหรือน้ำเกรปฟรุตกับยาบางชนิด",
        text: "ยาเพียงบางชนิดเท่านั้นที่มีปฏิกิริยากับเกรปฟรุต และผลอาจต่างกันตามยาและคน อย่าหยุดยาเอง แต่ถามเภสัชกรหรืออ่านเอกสารกำกับยาว่ายาของคุณต้องเลี่ยงเกรปฟรุต น้ำผลไม้ หรือผลไม้อื่นที่เกี่ยวข้องหรือไม่",
      },
      {
        title: "ยา อาหารเสริม และสมุนไพร",
        text: "คำว่า “ธรรมชาติ” ไม่ได้แปลว่าใช้ร่วมกับยาปลอดภัยเสมอไป นำรูปฉลากหรือรายการทั้งหมดให้แพทย์หรือเภสัชกรดูก่อนเริ่มผลิตภัณฑ์ใหม่ โดยเฉพาะเมื่อใช้ยาหลายชนิด",
      },
      {
        title: "ซื้อยาแก้หวัดหรือยาใช้เองเมื่อมีโรคประจำตัว",
        text: "ยาที่ซื้อได้เองบางชนิดมีคำเตือนสำหรับความดันสูง โรคหัวใจ เบาหวาน หรือโรคไต อ่านหัวข้อคำเตือนทุกครั้ง และถามเภสัชกรแทนการเดาว่ายาเหมาะกับโรคของตน",
      },
    ],
    situations: [
      {
        title: "ตู้ยาที่บ้าน",
        text: "แยกยาของแต่ละคนและคงฉลากเดิมไว้ ไม่วางยาไว้รวมกับขนมหรืออาหาร และเก็บให้พ้นมือเด็ก",
      },
      {
        title: "ซื้อยาหลายชนิด",
        text: "อ่านตัวยาสำคัญและบอกเภสัชกรว่ายา อาหารเสริม หรือสมุนไพรที่ใช้อยู่มีอะไร เพื่อหลีกเลี่ยงการเดาเรื่องตัวยาซ้ำ",
      },
      {
        title: "เดินทาง",
        text: "พกยาในภาชนะติดฉลากและเตรียมรายการยา ไม่ทิ้งยาไว้ในรถหรือที่ร้อนชื้นโดยไม่ตรวจคำแนะนำการเก็บ",
      },
    ],
    checklist: [
      "เทียบชื่อยาและความแรง",
      "อ่านวิธีใช้และวันหมดอายุ",
      "ตรวจคำเตือนและวิธีเก็บ",
      "เก็บรายการยาและการแพ้ยา",
      "ถามแพทย์หรือเภสัชกรเมื่อไม่ตรงกัน",
      "ตรวจตัวยาซ้ำในผลิตภัณฑ์หลายชนิด",
      "แจ้งยา อาหารเสริม และสมุนไพรทุกครั้ง",
    ],
  },
  en: {
    notice: [
      "A label identifies the medicine, strength, directions, warnings, expiry, and storage.",
      "Similar names or changed packaging can lead to selection errors.",
      "A change in colour, smell, shape, or texture may indicate deterioration even before the printed expiry.",
      "Pain, cold, and combination products can contain overlapping ingredients, so read active ingredients rather than relying only on brand names.",
    ],
    prepare: [
      "Keep medicine in its original labelled container and maintain a current medicine list.",
      "Ask a doctor or pharmacist if a label is unclear or differs from the instructions you received.",
      "Record medicines, supplements, herbal products, and medicine allergies to share with health professionals.",
      "Use reminders or organisers only when you can still track whose medicine, which day, and which dose it is; keep the original label available.",
    ],
    during: [
      "Check the name, strength, dose, and time on the label before every use.",
      "Use only according to the label and the professional directions for your medicine.",
      "Check warnings, storage, expiry, and the person's name when several people's medicines are kept nearby.",
      "At an appointment or when buying another medicine, share your current medicines, supplements, herbal products, and allergy history.",
    ],
    avoid: [
      "Do not use another person's medicine, share yours, or use expired medicine.",
      "Do not increase, reduce, stop, or combine medicines on your own when uncertain.",
      "Do not store medicine in a car, bathroom, direct sun, or humidity unless its specific label says otherwise.",
      "Do not crush, split, open a capsule, or change how a medicine is taken just to make it easier to swallow without asking a pharmacist.",
    ],
    help: [
      "Contact a doctor or pharmacist after a dosing error, unusual symptom, or suspected interaction.",
      "For severe symptoms such as breathing difficulty or unconsciousness, seek emergency help.",
      "If medicine is damaged, unlabelled, or of uncertain quality, separate it and ask a pharmacist before use or disposal.",
      "If a child or another person may have taken too much medicine or an unknown medicine, seek urgent advice and bring the container if safe to do so.",
    ],
    example:
      "A new medicine box looks like your usual one: check the name, strength, dose, directions, and expiry. If these differ from your instructions, ask a pharmacist before using it.",
    cautions: [
      {
        title: "Grapefruit or grapefruit juice with some medicines",
        text: "Only some medicines interact with grapefruit, and the effect differs by medicine and person. Do not stop a medicine yourself; ask a pharmacist or read its medicine information to find out whether your medicine requires avoiding grapefruit, juice, or related fruits.",
      },
      {
        title: "Medicines, supplements, and herbs",
        text: "“Natural” does not automatically mean safe with a medicine. Show a doctor or pharmacist the labels or a complete list before starting a new product, especially when you use several medicines.",
      },
      {
        title: "Over-the-counter medicine with a long-term condition",
        text: "Some non-prescription medicines carry warnings for high blood pressure, heart disease, diabetes, or kidney disease. Read the warnings every time and ask a pharmacist instead of assuming a product suits your condition.",
      },
    ],
    situations: [
      {
        title: "Home medicine cabinet",
        text: "Separate each person's medicines and keep original labels. Do not store medicine with snacks or food, and keep it out of children's reach.",
      },
      {
        title: "Buying several products",
        text: "Read active ingredients and tell the pharmacist about medicines, supplements, and herbs you use rather than guessing whether ingredients overlap.",
      },
      {
        title: "Travel",
        text: "Carry medicine in its labelled container with a medicine list. Do not leave it in a hot or humid vehicle without checking storage directions.",
      },
    ],
    checklist: [
      "Match the name and strength",
      "Read directions and expiry",
      "Check warnings and storage",
      "Keep a medicine and allergy list",
      "Ask a professional when details differ",
      "Check for duplicate active ingredients",
      "Share medicines, supplements, and herbs at every visit",
    ],
  },
};
